import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import LocalizedStrings from 'react-localization';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './StreamArtistsModal.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class StreamArtistsModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isCastOpen: false
		};
	}

	toggleCast = () => {
		this.setState({
			isCastOpen: !this.state.isCastOpen
		});
	}

	render() {
		let hasArtists = this.props.activeEvent && this.props.activeEvent.artists && this.props.activeEvent.artists.length > 0;
		return ( 
			<div>
		  		<Modal isOpen={this.props.isStreamArtistsModalOpen} toggle={this.props.toggleStreamArtistsModal} className="modal-stream-artists">
		          	<ModalHeader toggle={this.props.toggleStreamArtistsModal}>{strings.title}</ModalHeader>
					<ModalBody>
						{ hasArtists &&
						<div className="row">
							<div className="col-12">
								<div className="showtix-event__cast">
									<div className={"showtix-event__cast__mask" + (this.state.isCastOpen ? ' is-active' : '')}>
										<div className="row">
											{this.props.activeEvent.artists.map((artist, i) =>
												<div
													key={i}
													className="col-12 col-sm-6 col-md-4 text-center">
													<p><strong>{artist.position}</strong><br />{ReactHtmlParser(artist.first_name)} {ReactHtmlParser(artist.last_name)},</p>
												</div>
											)}
										</div>
									</div>
									{ this.props.activeEvent.artists.length > 6 &&
									<button
										className="showtix-event__cast__button"
										onClick={this.toggleCast}
									>
										{ this.state.isCastOpen ?
											strings.showLess
											:
											strings.showMore
										}
									</button>
									}
								</div>
							</div>
						</div>
						}
					</ModalBody>
					<ModalFooter className="justify-content-center">
						<button
							className="showtix-button showtix-background__primary-1"
							onClick={this.props.toggleStreamArtistsModal}
						>{strings.close}</button>
					</ModalFooter>
		        </Modal>
			</div>
		)
	}
}

StreamArtistsModal.propTypes = {
	activeEvent: PropTypes.object,
	isStreamArtistsModalOpen: PropTypes.bool,
	toggleStreamArtistsModal: PropTypes.func
}
 
export default StreamArtistsModal;


// WEBPACK FOOTER //
// ./src/components/Stream/StreamArtistsModal/StreamArtistsModal.js